import { JsonPipe, NgIf, NgTemplateOutlet } from '@angular/common';
import { ChangeDetectionStrategy, Component, Inject, Input } from '@angular/core';
import { MatTooltip } from '@angular/material/tooltip';
import { TAvailabilityView } from '@x/ecommerce-shop/app/core/availability/availability';
import { AvailabilityColorPipe } from '@x/ecommerce-shop/app/core/availability/availability-color.pipe';
import { ShopPillComponent } from '@x/ecommerce-shop/app/core/shop-ui/components/shop-pill/shop-pill.component';
import { IShopConfig, SHOP_CONFIG } from '@x/ecommerce-shop/config/shop.config';

@Component({
  selector: 'x-availability',
  standalone: true,
  imports: [NgIf, ShopPillComponent, MatTooltip, AvailabilityColorPipe, NgTemplateOutlet, JsonPipe],
  templateUrl: './availability.component.html',
  styleUrl: './availability.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AvailabilityComponent {
  @Input() availabilityView?: TAvailabilityView;
  @Input() availableRegions?: { name: string; label?: string | null; id: number }[];
  @Input() availableQuantity?: number | null;

  constructor(@Inject(SHOP_CONFIG) public shopConfig: IShopConfig) {}
}
